import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Text from '../../../shared/Text';
import Button from '../../../shared/Button';

export const IntroMessage = ({ onSuggestionClick, embed = false }) => {
  const { t } = useTranslation('hrAssistants');

  return (
    <Container>
      <Title embed={embed}>
        {t('intro.msg')}
        <Text color="primary.120">{t('intro.highlight')}</Text>
        {t('intro.questionMark')}
      </Title>
      {!embed && (
        <SuggestionContainer>
          <Suggestion
            onClick={() =>
              onSuggestionClick(t('suggestions.suggestion1.title'))
            }
          >
            <Text variant="h6">
              {`${t('suggestions.suggestion1.emoji')} ${t(
                'suggestions.suggestion1.title',
              )}`}
            </Text>
            <Text color="black.80" variant="body2">
              {t('suggestions.suggestion1.description')}
            </Text>
          </Suggestion>
          <Suggestion
            onClick={() =>
              onSuggestionClick(t('suggestions.suggestion2.title'))
            }
          >
            <Text variant="h6">
              {`${t('suggestions.suggestion2.emoji')} ${t(
                'suggestions.suggestion2.title',
              )}`}
            </Text>
            <Text color="black.80" variant="body2">
              {t('suggestions.suggestion2.description')}
            </Text>
          </Suggestion>
          <Suggestion
            onClick={() =>
              onSuggestionClick(t('suggestions.suggestion3.title'))
            }
          >
            <Text variant="h6">
              {`${t('suggestions.suggestion3.emoji')} ${t(
                'suggestions.suggestion3.title',
              )}`}
            </Text>
            <Text color="black.80" variant="body2">
              {t('suggestions.suggestion3.description')}
            </Text>
          </Suggestion>
          <Suggestion
            onClick={() =>
              onSuggestionClick(t('suggestions.suggestion4.title'))
            }
          >
            <Text variant="h6">
              {`${t('suggestions.suggestion4.emoji')} ${t(
                'suggestions.suggestion4.title',
              )}`}
            </Text>
            <Text color="black.80" variant="body2">
              {t('suggestions.suggestion4.description')}
            </Text>
          </Suggestion>
        </SuggestionContainer>
      )}
    </Container>
  );
};

IntroMessage.propTypes = {
  embed: PropTypes.bool,
  onSuggestionClick: PropTypes.func,
};

const Title = styled(Text).attrs({
  as: 'h3',
  fontSize: '30px',
  fontWeight: '600',
  padding: '30px 0px',
  margin: 0,
})`
  ${props =>
    props.embed &&
    css`
      font-size: 24px;
      padding: 24px 0px;
    `}
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  align-items: center;
`;

const SuggestionContainer = styled.div`
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Suggestion = styled(Button).attrs({
  mode: 'outline',
  variant: 'black',
})`
  border: 1px solid ${props => props.theme.colors.black[10]};
  border-radius: 10px;
  padding: 20px;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: left;

  :hover {
    color: ${props => props.theme.colors.black[100]};
    border-color: ${props => props.theme.colors.black[10]};
    background-color: ${props => props.theme.colors.black[10]};
  }
`;
